



























import { RemittanceMessage } from '@/utils/interfaces/remittance.interface'
import Vue, { PropType } from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  props: {
    message: Object as PropType<RemittanceMessage>,
    position: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    ...mapState(['profile']),
    ...mapState('remittanceChat', ['pending']),
    waiting(): boolean {
      if (this.message.promise && this.pending.includes(this.message.promise))
        return true
      return false
    },
  },
  methods: {
    asDate(value: string) {
      const date = new Date(value)
      return date.toLocaleDateString(this.profile.lang, {
        day: 'numeric',
        month: 'short',
      })
    },
  },
})
